export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly statusText: string,
    public readonly body: unknown,
  ) {
    super(`API ${status} ${statusText}`);
    this.name = 'ApiError';
  }
}

export class NotAuthenticatedError extends ApiError {
  constructor(body: unknown = null) {
    super(401, 'Unauthorized', body);
    this.name = 'NotAuthenticatedError';
  }
}

export class ForbiddenError extends ApiError {
  constructor(body: unknown = null) {
    super(403, 'Forbidden', body);
    this.name = 'ForbiddenError';
  }
}

/**
 * 404-specifieke variant zodat UI's "niet gevonden"-states kunnen renderen
 * zonder de generieke `ApiError` te inspecteren op status-code.
 */
export class NotFoundError extends ApiError {
  constructor(body: unknown = null) {
    super(404, 'Not Found', body);
    this.name = 'NotFoundError';
  }
}

/**
 * Story `fe-be-monteur-s5c-ingelogd-blijven` (S021.5c) §3.2 — de sessie was weg, en het
 * hervatten met het toestel-token kon NU niet (503 `resume_unavailable`, 429, of geen netwerk).
 * Bewust GEEN `NotAuthenticatedError`: de monteur hoort dan niet naar het inlogscherm, maar in
 * de bestaande fout-/offlinestaat te blijven tot een volgende poging lukt.
 */
export class ResumeUnavailableError extends ApiError {
  constructor(body: unknown = null) {
    super(503, 'Resume unavailable', body);
    this.name = 'ResumeUnavailableError';
  }
}

/**
 * Wordt niet meer client-side gegooid (server is autoritatief via [CsrfToken]),
 * maar blijft als export staan voor consumers die ernaar checken.
 */
export class CsrfError extends Error {
  constructor() {
    super('CSRF token not available — login first');
    this.name = 'CsrfError';
  }
}
